function includePayPalLibrary() {

    var paypalsrc = 'https://www.paypal.com/sdk/js?client-id=ASLZltuif0YCXsnyUlMgM-n1yr8W-CNysx4xf-JmKYgsqu0PIvgiMTRmcHmA9PJWiOdOmCthr1tXTaLU&vault=true&intent=subscription';


    var customScript = document.createElement('script');
    customScript.setAttribute('src', paypalsrc);
    customScript.setAttribute('data-sdk-integration-source', 'button-factory');
    document.head.appendChild(customScript);

}


function buildPayPalButtons(subscriptionId) {

    if (subscriptionId == 1) {
        paypal.Buttons({
            style: {
                shape: 'pill',
                color: 'blue',
                layout: 'horizontal',
                label: 'subscribe'
            },
            createSubscription: function (data, actions) {
                return actions.subscription.create({
                    /* Creates the subscription */
                    plan_id: 'P-3766896202940690CMCHMNXY',
                    quantity: 1 // The quantity of the product for a subscription
                });
            },
            onApprove: function (data, actions) {
                alert(data.subscriptionID); // You can add optional success message for the subscriber here
            }
        }).render('#paypal-button-container-P-3766896202940690CMCHMNXY'); // Renders the PayPal button
    }

}

